/* eslint-disable */

// Track cookie accept
jQuery(function () {
  jQuery('[data-cookie-accept]').click(function () {
    if (typeof gtag === 'function') {

      gtag('event', 'click', {
        'event_category': 'cookie',
        'event_label': 'accept'
      });
    }
  });

  let gtagEvents = document.querySelectorAll('[ga-on="click"]');
  gtagEvents.forEach((el) => {
    el.addEventListener('click', (e) => {
      const action = e.currentTarget.getAttribute('ga-event-action');
      const category = e.currentTarget.getAttribute('ga-event-category');
      const label = e.currentTarget.getAttribute('ga-event-label');

      sendGtagEvent(action, category, label);
    });
  });
});

function sendGtagEvent(action, category, label) {
  // Send event data to GA4 if function exists
  if (typeof gtag === 'function') {
    gtag('event', action, {
      'event_category': category,
      'event_label': label
    });
  }
}


// WEBPACK FOOTER //
// ./src/scripts/modules/eventTracking.js